module.exports = "https://coursera_assets.s3.amazonaws.com/images/3f91922230e7cf25ae9715f9d6a82a20.png";